import Vue from 'vue'
import axios from 'axios'
import {XSH5Utils} from '../utils/utils'
import {
  baseUrls
} from '../config/env'

//vue 实例
let vue = null
//是否允许显示toast
let showToast = true

const Axios = axios.create({
  baseURL: "/", // 因为我本地做了反向代理
  timeout: 10000,
  responseType: "json",
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  }
});

//请求开始时，开启加载中动画，出错了提示并关闭动画
Axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

//请求完成时，关闭加载中动画，返回数据或错误信息
Axios.interceptors.response.use(response => {
  //一切正常，返回数据或空对象
  if (response.data.code === 0) {
    return response.data.data || {}
  } else {
    //没有数据，只有提示信息，则弹出提示信息，
    if (response.data.text != null && response.data.text.length > 0) {
    }
  }
}, error => {
  if (error.response) {
    if (error.response.data.code === 10 || error.response.data.code === 6) {
      //未登录
      if (vue) {
        vue.$router.replace('/login')
      }
    }
    // 请求已发出，但服务器响应的状态码不在 2xx 范围内，有错误信息则弹出错误信息
    console.log('response-error-data', error.response.data)
    if (error.response.data.text != null && error.response.data.text.length > 0) {
    }
  } else {
    //什么数据都没有，直接出错了
  }
})
//加载小菊花是否显示
export function httpService(xsConfig, ignoreToken){
  var success = function (response) {
    //隐藏加载菊花
    // hideLoading();
    if(response.data.status.statuscode=="-998"){
      //session过期
      window.localStorage.removeItem("hrtk");
      window.localStorage.removeItem("mfud");
      window.localStorage.removeItem("mfnm");
      window.localStorage.removeItem("mfsd");
      window.localStorage.removeItem("mfavr");
      window.localStorage.removeItem("opid");
      window.localStorage.removeItem("mfvtr");
      let indexPath = window.location.protocol + "//" + window.location.host;
      window.location= indexPath;
      return;
    }
    //过滤掉message中括号
    if(response.data.status.statuscode != 0){
      response.data.status.message = response.data.status.message.replace('[', '');
      response.data.status.message = response.data.status.message.replace(']', '');
    }
    if(xsConfig.success) {
      if(response.data && response.data.data && response.data.data['dat' + 'a1']) {
        var str = XSH5Utils.decryptResponse(response.data.data['dat' + 'a1']);
        response.data.data = eval('(' + str + ')')
      }
      xsConfig.success(response.data);
    }
  };
  var failure = function (response) {
    //隐藏加载菊花
    // hideLoading();
    if(xsConfig.error) {
      xsConfig.error(response);
    }
    //$rootScope.showAlert("获取数据失败,请检查您的网络连接并刷新页面...");
  };
  axios(xsConfig).then(success, failure);
}
var getConfig = XSH5Utils.getHttpConfig.bind(XSH5Utils);
export function get (url, success, error, ignoreToken) {
  var xsConfig = getConfig( "GET", url, success, error);
  httpService(xsConfig, ignoreToken);
}

export function getSync(url, suc, err) {
  var xsConfig = getConfig("GET", url, suc, err);
  xsConfig.async = false;
  $.ajax(xsConfig);
}

export function getJSON( url, data, callback ) {
  return jQuery.get( url, data, callback, "json" );
}

export function post (url, data, success, error, ignoreToken) {
  var xsConfig = getConfig( "POST", url, success, error, data);
  httpService(xsConfig, ignoreToken);
}

export function put (url, data, success, error, ignoreToken) {
  var xsConfig = getConfig( "PUT", url, success, error, data);
  httpService(xsConfig, ignoreToken);
}

export function _delete(url, success, error, ignoreToken) {
  var xsConfig = getConfig( "DELETE", url, success, error);
  httpService(xsConfig, ignoreToken);
}
export default {
  get : get,
  post : post,
  put : put,
  delete : _delete,
  getSync : getSync,
  getJSON:getJSON
}



// WEBPACK FOOTER //
// ./src/utils/httpSrv.js